import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function TermsOfUse() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Monnaify Kullanım Koşulları</h1>
          <p className="legal-meta">Son güncelleme: 2026-04-17</p>
        </div>

        <p>
          Monnaify uygulamasını kullanarak bu kullanım koşullarını kabul etmiş sayılırsınız.
          Lütfen dikkatle okuyun.
        </p>

        <h2>Hizmetin Kullanımı</h2>
        <ul>
          <li>Monnaify, ortak harcamaları takip etmek için tasarlanmış bir uygulamadır.</li>
          <li>Hizmeti yalnızca yasal amaçlar için kullanabilirsiniz.</li>
          <li>Hesap güvenliğinizden siz sorumlusunuz.</li>
        </ul>

        <h2>Abonelik ve Ödemeler</h2>
        <ul>
          <li>Monnaify Pro, aylık veya yıllık olarak sunulan otomatik yenilenen bir aboneliktir.</li>
          <li>Abonelikler, mevcut dönem bitmeden en az 24 saat önce iptal edilmediği sürece otomatik olarak yenilenir.</li>
          <li>Aboneliğinizi App Store üzerinden yönetebilir veya iptal edebilirsiniz.</li>
          <li>Ödemeler, satın alım onayı üzerine Apple App Store hesabınızdan tahsil edilir.</li>
          <li>Mevcut abonelik dönemi için kısmi geri ödeme yapılmamaktadır.</li>
        </ul>

        <h2>Hesap Silme</h2>
        <p>
          Hesabınızı uygulama içindeki profil ayarlarından istediğiniz zaman silebilirsiniz.
          Hesap silindiğinde tüm verileriniz kalıcı olarak kaldırılır.
        </p>

        <h2>Sorumluluk Sınırlaması</h2>
        <p>
          Monnaify, hizmetin kesintisiz veya hatasız çalışacağını garanti etmez.
          Veri kaybı veya hizmet kesintisinden doğan zararlardan sorumlu tutulamaz.
        </p>

        <h2>Değişiklikler</h2>
        <p>
          Bu koşulları zaman zaman güncelleyebiliriz. Önemli değişiklikler için kullanıcılar bilgilendirilecektir.
        </p>

        <h2>İletişim</h2>
        <p>
          Sorularınız için: <a href="mailto:support@monnaify.app">support@monnaify.app</a>
        </p>

        <div className="legal-actions">
          <Link to="/privacy">Gizlilik Politikası</Link>
          <Link to="/">Giriş</Link>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
